import React from 'react';
import styled from 'styled-components';

const preventInvalidNumberKeys = (event) => {
  if (['e', 'E', '+', '-', '.'].includes(event.key)) event.preventDefault();
};

const isValidMarksInput = (next) => next === '' || /^\d+$/.test(next);

// Required "Marks" input. Numeric only; the consuming popup gates submit on a
// positive value being entered.
const ShowMarksControl = ({
  value,
  onValueChange,
  label = 'Marks',
  placeholder = 'e.g. 20',
  warning = '',
  required = true,
}) => {
  const handleValueChange = (event) => {
    const next = event.target.value;
    if (isValidMarksInput(next)) onValueChange(next);
  };

  return (
    <MarksCard>
      <LabelRow>
        <OptionLabel>
          {label}
          {required && <RequiredMark aria-label="required"> *</RequiredMark>}
        </OptionLabel>
      </LabelRow>
      <MarksInput
        type="number"
        min={1}
        step="1"
        inputMode="numeric"
        value={value}
        onChange={handleValueChange}
        onKeyDown={preventInvalidNumberKeys}
        placeholder={placeholder}
        required={required}
        aria-required={required}
      />
      {warning ? <WarningText role="alert">{warning}</WarningText> : null}
    </MarksCard>
  );
};

const MarksCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const OptionLabel = styled.label`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
`;

const OptionalBadge = styled.span`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 12px;
  color: #6f6a76;
`;

const RequiredMark = styled.span`
  color: #d92d20;
  margin-left: 2px;
`;

const MarksInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #c9c6cc;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #7200e0;
  }
`;

const WarningText = styled.p`
  margin: 0;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 12px;
  line-height: 1.4;
  color: #b54708;
`;

export default ShowMarksControl;
